// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/generations_service.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { RequestGenerationRequestSchema, RequestGenerationResponseSchema } from "./request_generation_pb";
import { file_vision_generations_v1_request_generation } from "./request_generation_pb";
import type { RegenerateGenerationRequestSchema, RegenerateGenerationResponseSchema } from "./regenerate_generation_pb";
import { file_vision_generations_v1_regenerate_generation } from "./regenerate_generation_pb";
import type { ListGenerationsByImageRequestSchema, ListGenerationsByImageResponseSchema } from "./list_generations_by_image_pb";
import { file_vision_generations_v1_list_generations_by_image } from "./list_generations_by_image_pb";
import type { ListRecentPromptsRequestSchema, ListRecentPromptsResponseSchema } from "./list_recent_prompts_pb";
import { file_vision_generations_v1_list_recent_prompts } from "./list_recent_prompts_pb";
import type { LikeGenerationRequestSchema, LikeGenerationResponseSchema } from "./like_generation_pb";
import { file_vision_generations_v1_like_generation } from "./like_generation_pb";
import type { UnlikeGenerationRequestSchema, UnlikeGenerationResponseSchema } from "./unlike_generation_pb";
import { file_vision_generations_v1_unlike_generation } from "./unlike_generation_pb";
import type { ApplyGenerationGradingRequestSchema, ApplyGenerationGradingResponseSchema } from "./apply_generation_grading_pb";
import { file_vision_generations_v1_apply_generation_grading } from "./apply_generation_grading_pb";
import type { ClearGenerationGradingRequestSchema, ClearGenerationGradingResponseSchema } from "./clear_generation_grading_pb";
import { file_vision_generations_v1_clear_generation_grading } from "./clear_generation_grading_pb";
import type { SetSelectedForDisplayRequestSchema, SetSelectedForDisplayResponseSchema } from "./set_selected_for_display_pb";
import { file_vision_generations_v1_set_selected_for_display } from "./set_selected_for_display_pb";
import type { ClearSelectedForDisplayRequestSchema, ClearSelectedForDisplayResponseSchema } from "./clear_selected_for_display_pb";
import { file_vision_generations_v1_clear_selected_for_display } from "./clear_selected_for_display_pb";
import type { SetGenerationCropRequestSchema, SetGenerationCropResponseSchema } from "./set_generation_crop_pb";
import { file_vision_generations_v1_set_generation_crop } from "./set_generation_crop_pb";
import type { ClearGenerationCropRequestSchema, ClearGenerationCropResponseSchema } from "./clear_generation_crop_pb";
import { file_vision_generations_v1_clear_generation_crop } from "./clear_generation_crop_pb";
import type { DeleteGenerationRequestSchema, DeleteGenerationResponseSchema } from "./delete_generation_pb";
import { file_vision_generations_v1_delete_generation } from "./delete_generation_pb";
import type { SetGenerationMaskRegionsRequestSchema, SetGenerationMaskRegionsResponseSchema } from "./set_generation_mask_regions_pb";
import { file_vision_generations_v1_set_generation_mask_regions } from "./set_generation_mask_regions_pb";
import type { ListVisionBoardGenerationsRequestSchema, ListVisionBoardGenerationsResponseSchema } from "./list_vision_board_generations_pb";
import { file_vision_generations_v1_list_vision_board_generations } from "./list_vision_board_generations_pb";
import type { DeleteVisionBoardGenerationsRequestSchema, DeleteVisionBoardGenerationsResponseSchema } from "./delete_vision_board_generations_pb";
import { file_vision_generations_v1_delete_vision_board_generations } from "./delete_vision_board_generations_pb";
import type { OptimizeVisionBoardPromptRequestSchema, OptimizeVisionBoardPromptResponseSchema } from "./optimize_vision_board_prompt_pb";
import { file_vision_generations_v1_optimize_vision_board_prompt } from "./optimize_vision_board_prompt_pb";
import type { OptimizeGenerationPromptRequestSchema, OptimizeGenerationPromptResponseSchema } from "./optimize_generation_prompt_pb";
import { file_vision_generations_v1_optimize_generation_prompt } from "./optimize_generation_prompt_pb";

/**
 * Describes the file vision/generations/v1/generations_service.proto.
 */
export const file_vision_generations_v1_generations_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_vision_generations_v1_request_generation, file_vision_generations_v1_regenerate_generation, file_vision_generations_v1_list_generations_by_image, file_vision_generations_v1_list_recent_prompts, file_vision_generations_v1_like_generation, file_vision_generations_v1_unlike_generation, file_vision_generations_v1_apply_generation_grading, file_vision_generations_v1_clear_generation_grading, file_vision_generations_v1_set_selected_for_display, file_vision_generations_v1_clear_selected_for_display, file_vision_generations_v1_set_generation_crop, file_vision_generations_v1_clear_generation_crop, file_vision_generations_v1_delete_generation, file_vision_generations_v1_set_generation_mask_regions, file_vision_generations_v1_list_vision_board_generations, file_vision_generations_v1_delete_vision_board_generations, file_vision_generations_v1_optimize_vision_board_prompt, file_vision_generations_v1_optimize_generation_prompt]);

/**
 * @generated from service protos.vision.generations.v1.VisionGenerations
 */
export const VisionGenerations: GenService<{
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.RequestGeneration
   */
  requestGeneration: {
    methodKind: "unary";
    input: typeof RequestGenerationRequestSchema;
    output: typeof RequestGenerationResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.RegenerateGeneration
   */
  regenerateGeneration: {
    methodKind: "unary";
    input: typeof RegenerateGenerationRequestSchema;
    output: typeof RegenerateGenerationResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.ListGenerationsByImage
   */
  listGenerationsByImage: {
    methodKind: "unary";
    input: typeof ListGenerationsByImageRequestSchema;
    output: typeof ListGenerationsByImageResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.ListRecentPrompts
   */
  listRecentPrompts: {
    methodKind: "unary";
    input: typeof ListRecentPromptsRequestSchema;
    output: typeof ListRecentPromptsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.ListVisionBoardGenerations
   */
  listVisionBoardGenerations: {
    methodKind: "unary";
    input: typeof ListVisionBoardGenerationsRequestSchema;
    output: typeof ListVisionBoardGenerationsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.DeleteVisionBoardGenerations
   */
  deleteVisionBoardGenerations: {
    methodKind: "unary";
    input: typeof DeleteVisionBoardGenerationsRequestSchema;
    output: typeof DeleteVisionBoardGenerationsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.OptimizeVisionBoardPrompt
   */
  optimizeVisionBoardPrompt: {
    methodKind: "unary";
    input: typeof OptimizeVisionBoardPromptRequestSchema;
    output: typeof OptimizeVisionBoardPromptResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.OptimizeGenerationPrompt
   */
  optimizeGenerationPrompt: {
    methodKind: "unary";
    input: typeof OptimizeGenerationPromptRequestSchema;
    output: typeof OptimizeGenerationPromptResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.LikeGeneration
   */
  likeGeneration: {
    methodKind: "unary";
    input: typeof LikeGenerationRequestSchema;
    output: typeof LikeGenerationResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.UnlikeGeneration
   */
  unlikeGeneration: {
    methodKind: "unary";
    input: typeof UnlikeGenerationRequestSchema;
    output: typeof UnlikeGenerationResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.ApplyGenerationGrading
   */
  applyGenerationGrading: {
    methodKind: "unary";
    input: typeof ApplyGenerationGradingRequestSchema;
    output: typeof ApplyGenerationGradingResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.ClearGenerationGrading
   */
  clearGenerationGrading: {
    methodKind: "unary";
    input: typeof ClearGenerationGradingRequestSchema;
    output: typeof ClearGenerationGradingResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.SetSelectedForDisplay
   */
  setSelectedForDisplay: {
    methodKind: "unary";
    input: typeof SetSelectedForDisplayRequestSchema;
    output: typeof SetSelectedForDisplayResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.ClearSelectedForDisplay
   */
  clearSelectedForDisplay: {
    methodKind: "unary";
    input: typeof ClearSelectedForDisplayRequestSchema;
    output: typeof ClearSelectedForDisplayResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.SetGenerationCrop
   */
  setGenerationCrop: {
    methodKind: "unary";
    input: typeof SetGenerationCropRequestSchema;
    output: typeof SetGenerationCropResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.ClearGenerationCrop
   */
  clearGenerationCrop: {
    methodKind: "unary";
    input: typeof ClearGenerationCropRequestSchema;
    output: typeof ClearGenerationCropResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.DeleteGeneration
   */
  deleteGeneration: {
    methodKind: "unary";
    input: typeof DeleteGenerationRequestSchema;
    output: typeof DeleteGenerationResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.generations.v1.VisionGenerations.SetGenerationMaskRegions
   */
  setGenerationMaskRegions: {
    methodKind: "unary";
    input: typeof SetGenerationMaskRegionsRequestSchema;
    output: typeof SetGenerationMaskRegionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vision_generations_v1_generations_service, 0);

